module.exports = Em.Handlebars.compile("<div class=\"window-body no-padding\">\n    {{{html}}}\n</div>\n");